























































































import {Component, Prop, Watch, Provide, Vue} from 'vue-property-decorator'
import {$, Helper} from 'simpli-web-sdk'
import {Motorista} from '@/model/resource/Motorista'
import {InputMotoristaSchema} from '@/schema/resource/Motorista/InputMotoristaSchema'
import {InputEnderecoMotoristaSchema} from '@/schema/resource/Endereco/InputEnderecoMotoristaSchema'
import {InputMotoristaJornadaSchema} from '@/schema/resource/MotoristaJornada/InputMotoristaJornadaSchema'
import {MotoristaJornada} from '@/model/resource/MotoristaJornada'
import {Endereco} from '@/model/resource/Endereco'

@Component
export default class PersistMotoristaView extends Vue {
  @Prop() id?: string

  @Provide('validator') validator = this.$validator

  schema = new InputMotoristaSchema()
  enderecoSchema = new InputEnderecoMotoristaSchema()
  jornadaSchema = new InputMotoristaJornadaSchema()
  motorista = new Motorista()

  Helper = Helper

  async created() {
    await this.populate()
    if (this.motorista.idMotoristaPk == 0) {
      this.motorista.endereco = new Endereco()
      this.motorista.jornadaMotorista = new MotoristaJornada()
    }
  }

  async populate() {
    const id = Number(this.id) || null

    if (id) {
      await this.motorista.getMotorista(id)
    }

    $.await.done('getMotorista')
  }

  formatData() {
    this.motorista.nome = this.motorista.nome?.toUpperCase() ?? null
    this.motorista.placaVeiculo =
      this.motorista.placaVeiculo?.toUpperCase() ?? null
    this.motorista.email = this.motorista.email?.toUpperCase() ?? null
    this.motorista.placaCarroceira =
      this.motorista.placaCarroceira?.toUpperCase() ?? null
    this.motorista.antt = this.motorista.antt?.toUpperCase() ?? null
    this.motorista.cnh = this.motorista.cnh?.toUpperCase() ?? null
    this.motorista.nomeIndicador =
      this.motorista.nomeIndicador?.toUpperCase() ?? null

    if (this.motorista.endereco) {
      this.motorista.endereco.logradouro =
        this.motorista.endereco.logradouro?.toUpperCase() ?? null
      this.motorista.endereco.bairro =
        this.motorista.endereco.bairro?.toUpperCase() ?? null
      this.motorista.endereco.cidade =
        this.motorista.endereco.cidade?.toUpperCase() ?? null
      this.motorista.endereco.uf =
        this.motorista.endereco.uf?.toUpperCase() ?? null
      this.motorista.endereco.pais =
        this.motorista.endereco.pais?.toUpperCase() ?? null
      this.motorista.endereco.complemento =
        this.motorista.endereco.complemento?.toUpperCase() ?? null
    }
  }

  async persist() {
    this.formatData()

    let isValid = await this.validator.validateAll()

    if (!this.motorista.nome) {
      Helper.abort('view.persistMotorista.error.nomeEmpty')
    }

    if (!this.motorista.cpf) {
      Helper.abort('view.persistMotorista.error.cpfEmpty')
    }

    if (!this.motorista.rg) {
      Helper.abort('view.persistMotorista.error.rgEmpty')
    }

    if (!this.motorista.celular) {
      Helper.abort('view.persistMotorista.error.celularEmpty')
    }

    if (!this.motorista.placaVeiculo) {
      Helper.abort('view.persistMotorista.error.placaVeiculoEmpty')
    }

    if (
      this.motorista.placaVeiculo !== null &&
      this.motorista.placaVeiculo.length < 7
    ) {
      Helper.abort('view.persistMotorista.error.placaVeiculoInvalid')
    }

    if (
      this.motorista.placaCarroceira !== null &&
      this.motorista.placaCarroceira.length < 7
    ) {
      Helper.abort('view.persistMotorista.error.placaCarroceiraInvalid')
    }

    if (!this.motorista.dataNascimento) {
      Helper.abort('view.persistMotorista.error.dataNascimentoEmty')
    }

    if (!this.motorista.tipoVeiculo) {
      Helper.abort('view.persistMotorista.error.tipoVeiculoEmpty')
    }

    if (!this.motorista.marcaVeiculo) {
      Helper.abort('view.persistMotorista.error.marcaVeiculoEmpty')
    }

    if (!isValid) {
      Helper.abort('system.error.validation')
    }

    await this.motorista.persistMotorista()
    await Helper.successAndPush('system.success.persist', '/motorista/list')
  }
}
